// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyAWwZMnZikfcXa4WjbGPgPTwP7NIPhWKvg',
    authDomain: 'laundryorder-47d74.firebaseapp.com',
    projectId: 'laundryorder-47d74',
    storageBucket: 'laundryorder-47d74.appspot.com',
    messagingSenderId: '852648657873',
    appId: '1:852648657873:web:d92fc28dc3dfe832e316f0',
    measurementId: 'G-FF9KC9LZLH'
  },
  //apiURL: 'http://localhost:8090/',
  apiURL: 'https://unclewash.net',
  kakaoKey: '99233308700dd7b214749c72c2e0a446',

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
